import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axios";

const emptyAccount = () => ({
  account_title: "",
  account_number: "",
  showField: {
    iban: false,
    swift_code: false,
    routing_code: false,
    transit_number: false,
    institution_number: false,
    ifsc: false,
    fedwire: false,
  },
  iban: "",
  swift_code: "",
  routing_code: "",
  transit_number: "",
  institution_number: "",
  ifsc: "",
  fedwire: "",
  opening_balance: 0,
  balance_type: "debit",
  freeze_account: false,
  freeze_as_on: null,
  freeze_type: null,
});

const BankForm = () => {
  const navigate = useNavigate();
  const [bankData, setBankData] = useState({
    branch: "",
    name: "",
    address: "",
    country: "",
    is_default: false,
    add_to_invoice: false,
    accounts: [emptyAccount()],
  });

  const handleBankChange = (e) => {
    const { name, value, type, checked } = e.target;
    setBankData({ ...bankData, [name]: type === "checkbox" ? checked : value });
  };

  const handleAccountChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const accounts = [...bankData.accounts];
    accounts[index][name] = type === "checkbox" ? checked : value;
    setBankData({ ...bankData, accounts });
  };

  const toggleField = (index, fieldName) => {
    const accounts = [...bankData.accounts];

    // allow ONLY ONE identifier at a time
    Object.keys(accounts[index].showField).forEach((key) => {
      if (key !== fieldName) {
        accounts[index].showField[key] = false;
        accounts[index][key] = "";
      }
    });

    accounts[index].showField[fieldName] = !accounts[index].showField[fieldName];
    setBankData({ ...bankData, accounts });
  };

  const addAccount = () => {
    setBankData({
      ...bankData,
      accounts: [...bankData.accounts, emptyAccount()],
    });
  };

  const cleanAccount = (acc) => {
    const identifiers = [
      "account_number",
      "iban",
      "swift_code",
      "routing_code",
      "transit_number",
      "institution_number",
      "ifsc",
      "fedwire",
    ];

    const cleaned = { ...acc };
    delete cleaned.showField;

    identifiers.forEach((key) => {
      if (!cleaned[key]) delete cleaned[key];
    });

    if (!cleaned.freeze_account) {
      delete cleaned.freeze_as_on;
      delete cleaned.freeze_type;
    }

    return cleaned;
  };

  const createBank = async (data) => {
    try {
      const payload = {
        ...data,
        accounts: data.accounts.map((acc) => cleanAccount(acc)),
      };

      console.log("FINAL PAYLOAD", payload);

      const response = await axios.post("banks/", payload);
      console.log("Bank created:", response.data);
      alert("Bank created successfully!");
      navigate("/dashboard/banks/list");
    } catch (error) {
      console.error("Error creating bank:", error.response?.data || error);
      alert("Failed to create bank. Check console for details.");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    createBank(bankData);
  };

  const accountFields = [
    { label: "IBAN", name: "iban" },
    { label: "SWIFT CODE", name: "swift_code" },
    { label: "Routing Code", name: "routing_code" },
    { label: "Transit Number", name: "transit_number" },
    { label: "Institution Number", name: "institution_number" },
    { label: "IFSC", name: "ifsc" },
    { label: "FEDWIRE Number", name: "fedwire" },
  ];

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="card-title mb-0">Create Bank</h4>
            <button className="btn btn-secondary" onClick={() => navigate("/dashboard")}>
              Back to Dashboard
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="row mb-3">
              <div className="col-md-6 mb-3">
                <label className="form-label">Bank Name</label>
                <input type="text" name="name" className="form-control" value={bankData.name} onChange={handleBankChange} required />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Branch</label>
                <input type="text" name="branch" className="form-control" value={bankData.branch} onChange={handleBankChange} />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Address</label>
                <input type="text" name="address" className="form-control" value={bankData.address} onChange={handleBankChange} />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Country</label>
                <input type="text" name="country" className="form-control" value={bankData.country} onChange={handleBankChange} />
              </div>
            </div>

            <hr />

            {bankData.accounts.map((account, index) => (
              <div key={index} className="card mb-3">
                <div className="card-body">
                  <h5 className="card-title">Account {index + 1}</h5>
                  <div className="row mb-3">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Account Title</label>
                      <input type="text" name="account_title" className="form-control" value={account.account_title} onChange={(e) => handleAccountChange(index, e)} required />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Account Number</label>
                      <input type="text" name="account_number" className="form-control" value={account.account_number} onChange={(e) => handleAccountChange(index, e)} required />
                    </div>
                  </div>

                  <div className="mb-3">
                    {accountFields.map((field) => (
                      <button key={field.name} type="button" className="btn btn-outline-primary btn-sm me-2 mb-2" onClick={() => toggleField(index, field.name)}>
                        {field.label}
                      </button>
                    ))}
                  </div>

                  <div className="row">
                    {accountFields.map(
                      (field) =>
                        account.showField[field.name] && (
                          <div key={field.name} className="col-md-6 mb-3">
                            <label className="form-label">{field.label}</label>
                            <input type="text" name={field.name} className="form-control" value={account[field.name]} onChange={(e) => handleAccountChange(index, e)} />
                          </div>
                        )
                    )}
                  </div>
                </div>
              </div>
            ))}

            <button type="button" className="btn btn-secondary mb-3" onClick={addAccount}>
              + Add Another Account
            </button>
            <br />
            <button type="submit" className="btn btn-primary">Create Bank</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BankForm;
